import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Course from '../../../api/v2/models/course'
import User from '../../models/user'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseButton',
  props: {
    course: {},
    user: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const title = ref('今すぐ受講する')
const buttonState = ref<'Apply' | 'Buy' | 'BuyPremium' | 'Continue'>('Apply')

onMounted(async () => {
  try {
    const enrollment = await api.enrollment.show({
      user_id: props.user.id,
      course_id: props.course.id
    })
    
    if (props.user.hasActiveSubscription && props.user.premiumCourseIds.indexOf(props.course.id) != -1){
      buttonState.value = 'Apply'
      title.value = '今すぐ受講する'
      if (enrollment && enrollment.id) {
        buttonState.value = 'Continue'
        title.value = '受講コースへ移動する（すでに受講済みです）'
      }
      return
    }

    if (enrollment && enrollment.id) {
      buttonState.value = 'Continue'
      title.value = '受講コースへ移動する（すでに受講済みです）'
      return
    }

    if (props.course.typeIs == 'product') {
      buttonState.value = 'Buy'
      title.value = '今すぐ購入する'
      return
    }

    buttonState.value = 'Apply'
    if (props.course.typeIs == 'text') {
      title.value = '今すぐ閲覧する'
      return
    }
    if (props.course.typeIs == 'free') {
      title.value = '今すぐ受講する【無料】'
      return
    }
    if (props.course.typeIs == 'premium') {
      buttonState.value = 'BuyPremium'
      title.value = 'プレミアムサービスを見る'
      return
    }
    title.value = '今すぐ受講する'
  } catch(e) {
  }
})

const buttonAction = async () => {
  switch(buttonState.value) {
    case 'Apply':
      try {
        await api.enrollment.create({
          user_id: props.user.id,
          course_id: props.course.id
        })
        return router.push({
          name: ROUTER_NAME.MY_COURSE_DETAIL,
          params: {
            examId: props.course.id.toString()
          }
        })
      } catch(e) {
      }
      return
    case 'Buy':
      return router.push({
        name: ROUTER_NAME.COURSE_PURCHASE,
        params: {
          examId: props.course.id.toString()
        }
      })
    case 'BuyPremium':
      return router.push({
        name: ROUTER_NAME.PREMIUM_SERVICE
      })
    case 'Continue':
      return router.push({
        name: ROUTER_NAME.MY_COURSE_DETAIL,
        params: {
          examId: props.course.id.toString()
        }
      })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    block: "",
    size: "large",
    variant: "flat",
    class: "text-white",
    color: "warning",
    onClick: buttonAction
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})